import { EventContext, Fields, Versions } from '@vimeo/bigpicture-client';

export const viewBpContextName = 'view_context';
type ViewerVersions = Versions<typeof viewBpContextName>;

export const buildViewBpContext = <V extends ViewerVersions>(
  fields: Fields<typeof viewBpContextName, V>,
  contextVersion: V,
) => {
  return {
    view_context: new EventContext(viewBpContextName, contextVersion, fields),
  };
};
